<template>
  <ul class="hover-list">
    <slot></slot>
  </ul>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.hover-list {
  @include reset-list;
}

.hover-list > li{
  padding: measure(quarter);
  border: 1px solid color(border-gray);
}

.hover-list > li:not(:last-child) {
  margin-bottom: measure(quarter);
}

.hover-list > li:hover {
  background-color: color(gray-6);
}
</style>
